jQuery.fn.Comments = function() {

	var $ = jQuery;

	var _this = this;

  _this.$modalReply = $( '.modal-reply', _this );
  _this.$formReply = $( '.form-reply', _this );
  _this.$modalReplies = $( '.modal-replies', _this );

	init_binds();

	function init_binds() {

		_this.$modalReply.on('show.bs.modal', function (event) {

			var button = $( event.relatedTarget );

			_this.$formReply.trigger( 'reset' );

			$( 'button[type=submit]', _this.$formReply ).attr( 'disabled', true );
	    $( 'button[type=submit]', _this.$formReply ).removeClass( 'd-none' );
	    $( '.form-body', _this.$formReply ).removeClass( 'd-none' );
	    $( '.form-success', _this.$formReply ).addClass( 'd-none' );

			var parentId = button.data( 'parent-id' );
			var parentTitle = button.data( 'parent-title' );

			$( 'input[name=parent]', _this.$formReply ).val( parentId );
			$( '.parent-title', _this.$formReply ).text( parentTitle );

		});

		_this.$modalReply.on('hide.bs.modal', function (event) {

			$( 'input[name=parent]', _this.$formReply ).val( '' );
			$( '.parent-title', _this.$formReply ).text( '' );

		});

		_this.$modalReplies.on('show.bs.modal', function (event) {

			var button = $( event.relatedTarget );

			var parentId = button.data( 'parent-id' );
			var parentTitle = button.data( 'parent-title' );

			_this.$modalReplies.attr( 'data-parent-id', parentId );

			$( '.parent-title', _this.$modalReplies ).text( parentTitle );

			ajax_get_comments( parentId );

		});

		_this.$modalReplies.on('hide.bs.modal', function (event) {

			_this.$modalReplies.removeAttr( 'data-parent-id' );

			$( '.parent-title', _this.$modalReplies ).text( '' );
			$( '.results', _this.$modalReplies ).html( '' );

		});

		$( 'input[name=terms-agreement]', _this.$formReply ).on('change', function() {

	    if (this.checked) {
	      $( 'button[type=submit]', _this.$formReply ).attr( 'disabled', false );
	    } else {
	      $( 'button[type=submit]', _this.$formReply ).attr( 'disabled', true );
	    }

	  });

		_this.$formReply.on( 'submit', function( e ) {

			e.preventDefault();

			grecaptcha.ready(function() {
	      grecaptcha.execute( recaptcha_data.site_key, { action: 'submit_comment' } ).then( async ( token ) => {

				// const result = await window.getRecaptchaResponse( token );

				// console.log( "Result: \n", result )

				// if ( !result.success ) {
				// 	return console.error( "Recaptcha Failed" );
				// }

	        	$( '.recaptcha-response', _this.$formReply ).val( token );
				ajax_add_comment( e );
	      });
	    });

		} );

	}

	function ajax_get_comments( post_id, page = 1 ) {

    $( '.loading-indicator', _this.$modalReplies ).show();

    var data = {
      page: page,
      post_id: post_id,
      action: 'get_engagement_comments'
    };

    $.ajax({
      'url': comments.ajax_url,
      'method': 'GET',
      data: data,
      success: function( result ) {
        $( '.results', _this.$modalReplies ).html( result );
      },
      error: console.error,
      complete: function() {
        $( '.loading-indicator', _this.$modalReplies ).hide();
      }
    });

  }

  function ajax_add_comment( e ) {

    e.preventDefault();

    $( 'button[type=submit]', _this.$formReply ).attr( 'disabled', true );

    var comment = new FormData( e.target );

    comment.append( 'action', 'add_engagement_comment' );

    $.ajax({
      url: comments.ajax_url,
      method: 'POST',
      contentType: false,
      processData: false,
      data: comment,
      success: function( result ) {

				$( '.form-body', _this.$formReply ).addClass( 'd-none' );

				$( 'button[type=submit]', _this.$formReply ).addClass( 'd-none' );
				$( 'button[type=submit]', _this.$formReply ).attr( 'disabled', true );

				$( '.form-success', _this.$formReply ).removeClass( 'd-none' );

      },
      error: console.error,
      complete: function() {
        $( 'button[type=submit]', _this.$formReply ).attr( 'disabled', false );
      }
    });

  }

	return _this;

};
